import { ICheckedProps } from "./Slider";

export const View = (props: ICheckedProps) => {
  return (
    <label className="switch">
      <input
        type="checkbox"
        onChange={() => props.onToggle(!props.checked)}
        checked={props.checked}
        disabled={props.isLoading}
      />
      <span className="slider round"></span>
    </label>
  );
};
